module.exports = __webpack_public_path__ + "img/2c6668ffa8e9053c32e288ed768a9b0d.png";